import fetch from "../utils/fetch";
import fetchWithTimeout from "../utils/fetchWithTimeout";
import CardCheckoutErrorCodes from "../constants/CardCheckoutErrorCodes";

function getCheckoutConfig(programId, locale, mode) {
  return new Promise((resolve, reject) => {
    fetch(`/api/checkout/${programId}/config?locale=${locale}&mode=${mode}`, 'GET')
      .then((response) => {
        resolve(response);
      })
      .catch((response) => {
        if (response && response.json) {
          response.json()
            .then((error) => {
              reject(error);
            })
            .catch(() => {
              reject({
                errorCode: CardCheckoutErrorCodes.CHECKOUT_UNAVAILABLE
              });
            });
        } else {
          reject({
            errorCode: CardCheckoutErrorCodes.CHECKOUT_UNAVAILABLE
          });
        }
      });
  });
}

function getCheckoutPricing(pricingRequest) {
  return new Promise((resolve, reject) => {
    fetch(`/api/checkout/pricing`, 'PUT', pricingRequest)
        .then((response) => {
          resolve(response);
        })
        .catch((response) => {
          if (response) {
            return response.json()
                .then((error) => {
                  reject(error);
                })
                .catch(() => {
                  reject({
                    errorCode: CardCheckoutErrorCodes.CHECKOUT_UNAVAILABLE
                  });
                });
          } else {
            reject({
              errorCode: CardCheckoutErrorCodes.CHECKOUT_UNAVAILABLE
            });
          }
          reject();
        });
  });
}

function checkBalance(checkBalanceRequest) {
  return new Promise((resolve, reject) => {
    fetch(`/api/checkout/balance-check`, 'PUT', checkBalanceRequest)
      .then((response) => {
        resolve(response);
      })
      .catch((response) => {
        if (response) {
          return response.json()
            .then((error) => {
              reject(error);
            })
            .catch(() => {
              reject({
                errorCode: CardCheckoutErrorCodes.CHECKOUT_UNAVAILABLE
              });
            });
        } else {
          reject({
            errorCode: CardCheckoutErrorCodes.CHECKOUT_UNAVAILABLE
          });
        }
        reject();
      });
  });
}

const encryptCardNumber = (cardNumber, prefix, exponent, modulus) => {
  return fetch(`/api/checkout/encrypt-card-number`, 'PUT', {
    cardNumber,
    prefix,
    exponent,
    modulus,
  })
    .then((response) => {
      if(response.encryptedCard) {
        return Promise.resolve(response.encryptedCard);
      } else {
        return Promise.reject("Error trying to encrypt card number.");
      }
    })
    .catch((response) => {
      return Promise.reject(response);
    });
};

const submitCheckout = (checkoutPurchaseRequest) => {
  return new Promise((resolve, reject) => {
    fetchWithTimeout(`/api/checkout/purchase`, 'POST', checkoutPurchaseRequest, 30000)
      .then((response) => {
        resolve(response);
      })
      .catch((response) => {
        try {
          if (response.json) {
            response.json()
              .then((errorResponse) => {
                reject(errorResponse);
              })
              .catch((e) => {
                reject(e);
              });
          } else {
            reject(response);
          }
        } catch (e) {
          reject(e);
        }
      });
  });
};

const createExternalCheckout = (createExternalCheckoutRequest) => {
  return fetch(`/api/checkout/external`, 'POST', createExternalCheckoutRequest)
    .then((response) => {
      if(response) {
        return Promise.resolve(response);
      } else {
        return Promise.reject("Error trying to create external checkout.");
      }
    })
    .catch((response) => {
      return Promise.reject(response);
    });
};

export default {
  checkBalance,
  getCheckoutConfig,
  getCheckoutPricing,
  encryptCardNumber,
  submitCheckout,
  createExternalCheckout
};
